import { render, staticRenderFns } from "./Example.vue?vue&type=template&id=6aace0f4&scoped=true"
import script from "./Example.vue?vue&type=script&lang=js"
export * from "./Example.vue?vue&type=script&lang=js"
import style0 from "./Example.vue?vue&type=style&index=0&id=6aace0f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aace0f4",
  null
  
)

export default component.exports